export function openZohoChat(event) {
  if (event?.preventDefault) event.preventDefault();
  if (typeof window === 'undefined') return;

  const show = () => {
    try {
      if (window.$zoho?.salesiq?.floatwindow?.visible) {
        window.$zoho.salesiq.floatwindow.visible('show');
        return true;
      }
    } catch {
      /* ignore */
    }
    return false;
  };

  if (show()) return;

  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};
  const priorReady = window.$zoho.salesiq.ready;
  window.$zoho.salesiq.ready = function ready() {
    if (typeof priorReady === 'function') priorReady();
    show();
  };

  if (!document.getElementById('zsiqscript')) {
    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.defer = true;
    script.src =
      'https://salesiq.zohopublic.in/widget?wc=siq6819f6263d8dad7e7566213151b3ac283651dc413c53dd3e9074a8a1b079982e';
    document.body.appendChild(script);
  }

  let tries = 0;
  const poll = window.setInterval(() => {
    tries += 1;
    if (show() || tries > 40) window.clearInterval(poll);
  }, 250);
}
